<template
  ><v-container >
    <v-row class="align-center  mb-2">
      <v-col class="d-flex justify-end">
        <v-btn
          color="primary"
          v-if="isInRole(2)"
          @click="$refs.feedbackDialog.showDialog(sourceGuid)"
        >
          <v-icon left>mdi-plus</v-icon>
          {{ $t("portfolio.Feedback.add") }}
        </v-btn>
      </v-col>
    </v-row>
   <Feedbacks
          showNoData
          :showTitle="false"
          ref="feedbacks"
          :sourceType="sourceType"
          :sourceGuid="sourceGuid"
          v-model="feedbacks"
        />
    <FeedbackDialog
      ref="feedbackDialog"
      @add="addFeedbackHandler"
      :sourceType="sourceType"
    /> </v-container
></template>
<script>
import FeedbackDialog from "../../../../components/portfolio/feedback/feedbackDialog.vue";
import Feedbacks from "../../../../components/portfolio/feedback/feedbacks.vue";

export default {
  components: {
    FeedbackDialog,
    Feedbacks
  },
  data() {
    return {
      feedbacks: [],
      loading: false
    };
  },
  created() {
    this.getFeedbacks();
  },
  methods: {
    addFeedbackHandler(x) {
      this.$refs.feedbacks.addFeedback(x);
    },
    async getFeedbacks() {
      this.loading = true;
      await this.axios
        .get("Feedback/Get", {
          params: {
            sourceGuid: this.sourceGuid,
            sourceType: this.sourceType
          }
        })
        .then(res => {
          this.feedbacks = res.data.data;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  props: {
    sourceGuid: {
      type: String,
      required: true
    },
    sourceType: {
      type: String,
      required: true
    }
  }
};
</script>
